import React from 'react';

// maplibre and the geocoder are hefty, so they download with the map
const GeocoderControl = React.lazy(() => import('./GeocoderControl'));

export interface BambiMapSearchProps {
  flyToZoom: number;
  markerColor: string;
}

export function BambiMapSearch({
  flyToZoom,
  markerColor,
}: BambiMapSearchProps) {
  return (
    <div data-testid="bambi-map-search">
      <GeocoderControl flyToZoom={flyToZoom} markerColor={markerColor} />
    </div>
  );
}
